import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=19a7e95a&"
import script from "./FolderIcon.vue?vue&type=script&lang=ts&"
export * from "./FolderIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports